import { render, staticRenderFns } from "./InventoryOrder.vue?vue&type=template&id=83aa7802&scoped=true"
import script from "./InventoryOrder.vue?vue&type=script&lang=js"
export * from "./InventoryOrder.vue?vue&type=script&lang=js"
import style0 from "./InventoryOrder.vue?vue&type=style&index=0&id=83aa7802&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83aa7802",
  null
  
)

export default component.exports